import { createContext } from 'react';

import type { CurrentWorkspace } from '@mio/shared';
import type { Session, User } from '@supabase/supabase-js';

export type AuthStatus = 'loading' | 'authenticated' | 'anonymous';
export type SignOutGuard = (current: CurrentWorkspace) => Promise<void>;
export interface SignOutOptions {
  /** Skip workspace preparation after the learner has seen why it failed and chose to proceed. */
  force?: boolean;
}

export interface AuthState {
  status: AuthStatus;
  session: Session | null;
  user: User | null;
  signOut: (options?: SignOutOptions) => Promise<void>;
  signingOut: boolean;
  registerSignOutGuard: (guard: SignOutGuard, scope?: 'workshop') => () => void;
}

export const AuthContext = createContext<AuthState | null>(null);
